import * as tslib_1 from "tslib";
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var UiMatPaginatorIntl = /** @class */ (function (_super) {
    tslib_1.__extends(UiMatPaginatorIntl, _super);
    function UiMatPaginatorIntl(_translateService, appState) {
        var _this = _super.call(this) || this;
        _this._translateService = _translateService;
        _this.firstPageLabel = '';
        _this.lastPageLabel = '';
        _this.itemsPerPageLabel = '';
        _this.nextPageLabel = '';
        _this.previousPageLabel = '';
        _this._firstPageLabelKey = 'paginator_first_page';
        _this._lastPageLabelKey = 'paginator_last_page';
        _this._itemsPerPageLabelKey = 'grid_items';
        _this._nextPageLabelKey = 'paginator_next_page';
        _this._previousPageLabelKey = 'paginator_previous_page';
        _this._destroyed$ = new Subject();
        _this.getRangeLabel = function (page, pageSize, length) {
            length = Math.max(length, 0);
            var startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            var endIndex = startIndex < length ?
                Math.min(startIndex + pageSize, length) :
                startIndex + pageSize;
            return startIndex + 1 + ' - ' + endIndex + ' / ' + length;
        };
        _this._setTranslations = function () {
            _this.firstPageLabel = _this._translateService.instant(_this._firstPageLabelKey);
            _this.lastPageLabel = _this._translateService.instant(_this._lastPageLabelKey);
            _this.itemsPerPageLabel = _this._translateService.instant(_this._itemsPerPageLabelKey);
            _this.nextPageLabel = _this._translateService.instant(_this._nextPageLabelKey);
            _this.previousPageLabel = _this._translateService.instant(_this._previousPageLabelKey);
            _this.changes.next();
        };
        appState.language.value$
            .pipe(takeUntil(_this._destroyed$))
            .subscribe(_this._setTranslations);
        return _this;
    }
    UiMatPaginatorIntl.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
        this.changes.complete();
    };
    return UiMatPaginatorIntl;
}(MatPaginatorIntl));
export { UiMatPaginatorIntl };
